export const navigationMemoryFeatureKey = 'navigationMemory';

/**
 * Generic, reusable memory slot for state that must survive a navigation
 * round-trip (e.g. a drill-down then a direct return). Modelled on the search
 * store's hop mechanism (`temporaryActiveFilters`) but decoupled from
 * `activeFilters`.
 *
 * Any screen that holds its state in local component state (custom dropdowns,
 * scroll position, selection…) can stash it here before leaving and restore it
 * on a direct return. `payload` is opaque: the owning context casts it back.
 */
export interface INavigationMemoryState {
  /** Owning context discriminator, e.g. 'salesComparison'. */
  key: string;
  /** Structured state to restore, cast back by the consumer. */
  payload: unknown;
  /** Origin URL (the source screen) the memory belongs to. */
  urlSource: string;
  /** Target URL navigated to, supplied by the caller (e.g. smart-action-link). */
  urlTarget: string;
  /** Number of off-path navigations since the memory was armed. */
  hop: number;
}
